import { $ } from '@/Engine/stateInstance';

export const onNoWallIntersection = () => {
    $.wardrobe.removeModuleByUUID('temp');
    $.removeDoorByUUID('temp');
    $.removeWindowsByUUID('temp');
    $.tempShelf = null;
};
